// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__busOj","left":"styles_left__5TV_r","right":"styles_right__c9Fpv","image":"styles_image__XST1I","text":"styles_text__croA1","title":"styles_title__0f7je"};